<template>
  <div class="goods-image">
    <!-- 大图 -->
    <div
      v-show="show"
      class="large"
      :style="[{ backgroundImage: `url(${currentImg})` }, largePosition]"
    ></div>
    <!-- 中图 -->
    <div
      class="middle"
      ref="target"
      @mouseenter="state.isEnterImg = true"
      @mouseleave="state.isEnterImg = false"
    >
      <img class="img" :src="currentImg" referrerpolicy="no-referrer" alt="" ref="imgRef" />
      <!-- 遮罩色块 -->
      <div v-show="show" class="layer" :style="layerPosition"></div>
    </div>
    <!-- 小图 -->
    <ul class="small">
      <li v-for="(img, i) in images" :key="img" :class="{ active: i === currIndex }">
        <img referrerpolicy="no-referrer" @click="clickImage(i, 'small')" :src="img" alt="" />
      </li>
    </ul>
    <div class="share-block">
      <div class="share-item share-item1" @click="shareClick">
        <span class="iconfont icon-share"></span>
        <span class="share-text">{{ $t('pecenter.affiliateShare') }}</span>
      </div>
      <div class="share-item" @click="starClick">
        <span
          class="iconfont"
          :class="{
            'icon-a-lujing1': $props.isStar,
            'icon-lujing1': !$props.isStar,
          }"
        ></span>
        <span class="share-text">{{ $t('pecenter.affiliateFavorite') }}</span>
      </div>
    </div>

    <div v-if="$props.photosList.length" class="qc-img">
      <div class="qc-label">{{ $t('product.qcImg') }}</div>
      <ul class="small">
        <li v-for="(img, i) in $props.photosList" :key="img" :class="{ active: i === currIndex }">
          <!-- <img :src="`${img.photoUrl}?x-oss-process=image/resize,l_80,h_80`" alt="" /> -->
          <el-image
            style="width: 100%; height: 100%"
            referrerpolicy="no-referrer"
            :key="i"
            :src="`${img.photoUrl}?x-oss-process=image/resize,l_80,h_80/format,webp`"
            :zoom-rate="1.2"
            :max-scale="7"
            teleported
            :initial-index="i"
            fit="cover"
            @click="openViewer(i)"
          />
        </li>
      </ul>
    </div>
  </div>
  <el-image-viewer
    v-if="state.isShowViewer"
    v-model="state.isShowViewer"
    :initial-index="state.currIndex"
    :url-list="
      $props.photosList.map(
        (item) => `${item.photoUrl}?x-oss-process=image/format,webp&timeStamp=${timeStamp}`,
      )
    "
    @close="closeViewer"
  ></el-image-viewer>
</template>
<script setup>
import { useMouseInElement } from '@vueuse/core'
import { computed, defineEmits, defineProps, nextTick, onMounted, reactive, ref, watch } from 'vue'
const $emit = defineEmits(['update:currentImg', 'shareClick', 'collectGoodsClick'])
const $props = defineProps({
  images: {
    type: Array,
    default: () => [],
  },
  currentImg: {
    type: String,
    default: '',
  },
  goodsId: {
    type: String,
    default: '',
  },
  isStar: {
    type: Boolean,
    default: false,
  },
  photosList: {
    type: Array,
    default: () => [],
  },
})
const state = reactive({
  imgHeight: 0,
  isEnterImg: false,
  isShowViewer: false,
})
const timeStamp = Date.now()
const imgRef = ref()
const currentImg = computed({
  get() {
    return $props.currentImg
  },
  set(img) {
    $emit('update:currentImg', img)
  },
})
// 当前预览图的索引
const currIndex = ref(0)
// 打开预览图
const openViewer = (index) => {
  state.isShowViewer = true
  state.currIndex = index
}
// 关闭预览图
const closeViewer = () => {
  state.isShowViewer = false
}
const setCurrentImage = (imgUrl) => {
  currentImg.value = imgUrl
}
setCurrentImage($props.images[currIndex.value])
const clickImage = (index, type) => {
  currIndex.value = index
  setCurrentImage(
    type === 'small'
      ? $props.images[index]
      : `${$props.photosList[index].photoUrl}?timeStamp=${timeStamp}`,
  )
}
// 1. 是否显示遮罩和大图
const show = ref(false)
// 2. 遮罩的坐标(样式)
const layerPosition = reactive({
  left: 0,
  top: 0,
})
// 3. 大图背景定位(样式)
const largePosition = reactive({
  backgroundPositionX: 0,
  backgroundPositionY: 0,
})
// 4. 使用useMouseInElement得到基于元素左上角的坐标和是否离开元素数据
const target = ref(null)
const { elementX, elementY, isOutside } = useMouseInElement(target)
watch([elementX, elementY, isOutside], () => {
  if (!state.isEnterImg) {
    show.value = false
    return
  }
  // 5. 根据得到数据设置样式数据和是否显示数据
  show.value = !isOutside.value
  // 计算坐标
  const position = { x: 0, y: 0 }

  if (elementX.value < 160) position.x = 0
  else if (elementX.value > 480) position.x = 320
  else position.x = elementX.value - 160

  if (elementY.value < 160) position.y = 0
  else if (elementY.value > state.imgHeight - 160) position.y = state.imgHeight - 320
  else position.y = elementY.value - 160
  // 给样式赋值
  layerPosition.left = position.x + 'px'
  layerPosition.top = position.y + 'px'
  largePosition.backgroundPositionX = -2 * position.x + 'px'
  largePosition.backgroundPositionY = -2 * position.y + 'px'
})

onMounted(() => {
  setTimeout(() => {
    nextTick(() => {
      state.imgHeight = imgRef.value.scrollHeight
    })
  }, 100)
})
const shareClick = () => {
  $emit('shareClick')
}
const starClick = () => {
  $emit('collectGoodsClick')
}

watch(
  () => currentImg.value,
  () => {
    nextTick(() => {
      state.imgHeight = imgRef.value.scrollHeight
    })
  },
)
</script>
<style scoped lang="scss">
.goods-image {
  width: 100%;
  position: relative;
  z-index: 200;
  position: sticky;

  top: 80px;

  .large {
    position: absolute;
    top: 0;
    left: 640px;
    width: 640px;
    height: 640px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    background-repeat: no-repeat;
    background-size: 1280px auto;
    background-color: #f8f8f8;
    border-radius: 8px;
    overflow: hidden;
  }

  .middle {
    width: 100%;
    object-fit: fill;
    object-position: center;
    background: #f5f5f5;
    position: relative;
    cursor: move;
    border-radius: 8px;
    overflow: hidden;

    .img {
      width: 100%;
    }

    .layer {
      width: 320px;
      height: 320px;
      background: rgba(0, 0, 0, 0.2);
      left: 0;
      top: 0;
      position: absolute;
    }
  }

  .small {
    width: 100%;
    margin-top: 20px;
    display: flex;
    flex-wrap: wrap;

    // overflow: hidden;
    li {
      width: 113px;
      height: 113px;
      margin-right: 18px;
      margin-bottom: 18px;
      box-sizing: border-box;
      cursor: pointer;
      overflow: hidden;
      border: 2px solid transparent;
      border-radius: 4px;

      &:nth-of-type(5n) {
        margin-right: 0;
      }

      &.active {
        border-color: var(--primary-color);
      }
    }
  }

  .share-block {
    color: var(--black-color-9);
    display: flex;
    justify-content: flex-end;
    align-items: center;

    .share-item {
      .iconfont {
        margin-right: 4px;
        font-size: 14px;
        cursor: pointer;
      }

      .share-text {
        font-size: 14px;
        cursor: pointer;
      }

      .icon-lujing1 {
        color: var(--black-color-9);
        font-size: 16px;
      }

      .icon-a-lujing1 {
        color: #ff8f1f;
        font-size: 16px;
      }
    }

    .share-item1 {
      margin-right: 24px;
    }
  }

  .qc-img {
    .qc-label {
      font-size: 18px;
      font-weight: bold;
      line-height: normal;
      color: var(--black-color-9);
      margin-bottom: 18px;
      margin-top: 16px;
    }

    .small {
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
      }
    }
  }
}
</style>
